export default __webpack_public_path__ + "static/media/Group9249.11fb7b90.svg";